import { render, staticRenderFns } from "./bulk-message-sentiment-forecast.vue?vue&type=template&id=aca15664&scoped=true&"
import script from "./bulk-message-sentiment-forecast.vue?vue&type=script&lang=js&"
export * from "./bulk-message-sentiment-forecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca15664",
  null
  
)

export default component.exports